import { createSelector } from "reselect";
import { getCurrentMockId } from "./mockSelectors";

const getDiscardChoices = (state) => state.discardChoices || [];

export const makeDiscardChoice = createSelector(
  getDiscardChoices,
  (_, choiceId, questionStemId) => ({ choiceId, questionStemId }),
  getCurrentMockId,
  (discardChoices, { choiceId, questionStemId }, mockId) => {
    return !!discardChoices.find(
      (dC) =>
        dC.choiceId == choiceId &&
        dC.mockId == mockId &&
        dC.questionStemId == questionStemId
    );
  }
);
